import React from 'react';
import { useStoreState } from 'easy-peasy';
import SectionTopMenu from '../../shared/components/SectionTopMenu/SectionTopMenu';
import HomeGallery from './components/HomeGallery';

const Home = () => {
  const clients = useStoreState(state => state.clients);
  return (
    <div>
      <SectionTopMenu clientName="Admin Home" />
      <HomeGallery items={clients} />
    </div>
);
};

export default Home;
